import CTNDropdownButton from '@ctn/ui/components/ctn-dropdown-button';
import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';

import TextIcon from '@/components/TextIcon';

import { getIconDocumento } from '@/helpers/upload';
import type { IRepresentante } from '@/interfaces/model/don.interface';
import { type ILookup } from '@/interfaces/model/generic.interface';
import { getFullName } from '@/utils/string/string';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';

const getColumns = ({
	onDelete,
	onEdit,
	isDisplay,
	verDocumento,
}: {
	onDelete?: (value: IRepresentante) => void;
	onEdit?: (value: IRepresentante) => void;
	isDisplay?: boolean;
	verDocumento?: any;
}) => {
	const columns: Array<CustomColumnDef<IRepresentante>> = [
		{
			accessorKey: 'tipoDocumentoIdent',
			header: 'Tipo documento',
			enableSorting: false,
			th: {
				width: 150,
			},
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				const value = (getValue() as ILookup)?.descripcion || '';
				return <CTNEllipsis content={value} />;
			},
		},
		{
			accessorKey: 'numeroDocumento',
			header: 'Nº Documento',
			enableSorting: false,
			th: {
				width: 140,
			},
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				return <CTNEllipsis content={getValue() as string} />;
			},
		},
		{
			accessorKey: 'name',
			header: 'Nombre',
			enableSorting: false,
			responsive: {
				sizeColumn: 'full',
			},
			cell({ row }) {
				const { nombre, apellido1RacSoc, apellido2 } = row.original;
				const fullName = getFullName(nombre, apellido1RacSoc, apellido2);
				return <CTNEllipsis content={fullName} />;
			},
		},
		{
			accessorKey: 'telefono',
			header: 'Telefono',
			enableSorting: false,
			responsive: {
				sizeColumn: 'full',
			},
			cell({ row }) {
				const { telefonoNumero } = row.original;
				return <CTNEllipsis content={telefonoNumero} />;
			},
		},
		{
			accessorKey: 'email',
			header: 'Email',
			enableSorting: false,
			responsive: {
				sizeColumn: 'full',
			},
			cell({ row }) {
				const { email } = row.original;
				return <CTNEllipsis content={email} />;
			},
		},
	];

	if (isDisplay) {
		columns.push(
			{
				accessorKey: 'nombre',
				header: 'Nombre documento',
				enableSorting: false,
				responsive: { sizeColumn: 'full' },
				cell: ({ row }) => (
					<TextIcon
						iconLeft={{ icon: getIconDocumento(row.original.documentoPoder) }}
						description={row.original.documentoPoder.nombre}
					/>
				),
			},
			{
				accessorKey: 'document',
				header: '',
				enableSorting: false,
				responsive: {
					sizeColumn: 'full',
				},
				cell({ row }) {										
					return (
						<CTNDropdownButton
							variant="ghost"
							mode="secondary"
							size="size-32"
							label="Acciones"
							icon={[{ icon: 'moreVertical', color: 'none', position: 'left' }]}
							items={[
								{ label: 'Ver documento', onClick: () => verDocumento(row.original.documentoPoder, row.original.id) },
							]}
						/>
					);
				},
			},
		);
	} else if (onDelete && onEdit) {
		columns.push({
			accessorKey: 'actions',
			enableSorting: false,
			header: '',
			th: {
				width: 48,
			},
			td: {
				align: 'center',
			},
			responsive: { sizeColumn: 'full' },
			cell: ({ row }) => (
				<CTNDropdownButton
					variant="ghost"
					mode="secondary"
					size="size-32"
					label="Acciones"
					icon={[{ icon: 'moreVertical', color: 'none', position: 'left' }]}
					items={[
						{ label: 'Editar', onClick: () => onEdit(row.original) },
						{ label: 'Eliminar', onClick: () => onDelete(row.original) },
					]}
				/>
			),
		});
	}
	return columns;
};

export { getColumns };
